"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmptyQuestion = exports.createNewAnswerSurvey = exports.createEmptySurvey = exports.isSurveyExpired = exports.timeSinceEpoch = exports.createEmptyResponses = exports.ResponseStatus = exports.SurveyTypes = exports.QuestionTypes = exports.UserTypes = exports.ButtonTypes = void 0;
const shortid_1 = __importDefault(require("shortid"));
const packageJson = __importStar(require("../package.json"));
var ButtonTypes;
(function (ButtonTypes) {
    ButtonTypes[ButtonTypes["primary"] = 0] = "primary";
    ButtonTypes[ButtonTypes["secondary"] = 1] = "secondary";
    ButtonTypes[ButtonTypes["tertiary"] = 2] = "tertiary";
    ButtonTypes[ButtonTypes["ghost"] = 3] = "ghost";
})(ButtonTypes = exports.ButtonTypes || (exports.ButtonTypes = {}));
var UserTypes;
(function (UserTypes) {
    UserTypes["initial"] = "initial";
    UserTypes["admin"] = "admin";
    UserTypes["owner"] = "owner";
    UserTypes["respondent"] = "respondent";
})(UserTypes = exports.UserTypes || (exports.UserTypes = {}));
var QuestionTypes;
(function (QuestionTypes) {
    QuestionTypes[QuestionTypes["trueFalse"] = 0] = "trueFalse";
    QuestionTypes[QuestionTypes["multipleChoice"] = 1] = "multipleChoice";
    QuestionTypes[QuestionTypes["openEnded"] = 2] = "openEnded";
    QuestionTypes[QuestionTypes["checkboxes"] = 3] = "checkboxes";
})(QuestionTypes = exports.QuestionTypes || (exports.QuestionTypes = {}));
var SurveyTypes;
(function (SurveyTypes) {
    SurveyTypes["private"] = "private";
    SurveyTypes["public"] = "public";
})(SurveyTypes = exports.SurveyTypes || (exports.SurveyTypes = {}));
var ResponseStatus;
(function (ResponseStatus) {
    ResponseStatus["Undeliverable"] = "Undeliverable";
    ResponseStatus["AwaitingResponse"] = "Awaiting Response";
    ResponseStatus["Started"] = "Started";
    ResponseStatus["Responded"] = "Responded";
})(ResponseStatus = exports.ResponseStatus || (exports.ResponseStatus = {}));
exports.createEmptyResponses = (questionType) => {
    let emptyResponses = [];
    switch (questionType) {
        case QuestionTypes.multipleChoice:
            emptyResponses = [
                { id: shortid_1.default.generate(), value: '' },
                { id: shortid_1.default.generate(), value: '' },
            ];
            break;
        case QuestionTypes.checkboxes:
            emptyResponses = [
                { id: shortid_1.default.generate(), value: '' },
                { id: shortid_1.default.generate(), value: '' },
            ];
            break;
        case QuestionTypes.trueFalse:
            emptyResponses = [
                { id: shortid_1.default.generate(), value: 'Yes' },
                { id: shortid_1.default.generate(), value: 'No' },
            ];
            break;
        case QuestionTypes.openEnded:
            emptyResponses = [{ id: shortid_1.default.generate(), value: '' }];
            break;
    }
    return emptyResponses;
};
exports.timeSinceEpoch = () => new Date().getTime();
function isSurveyExpired(survey) {
    let expired = false;
    const now = new Date().getTime();
    if (survey.endDate && now > survey.endDate)
        expired = true;
    if (survey.maxNumDays &&
        survey.dateReceived &&
        now >
            new Date(survey.dateReceived).getTime() +
                survey.maxNumDays * 24 * 60 * 60 * 1000)
        expired = true;
    //TODO: evaluate for max responses!
    return expired;
}
exports.isSurveyExpired = isSurveyExpired;
exports.createEmptySurvey = () => {
    return {
        version: packageJson.version,
        name: '',
        description: '',
        topics: ['General'],
        questions: [],
        id: '',
        createdBy: '',
        dateCreated: exports.timeSinceEpoch(),
        dateSent: null,
        numResponses: 0,
        owners: [],
        logoUrl: null,
        type: SurveyTypes.private,
        hideUserStats: false,
        endDate: null,
        maxNumDays: null,
    };
};
// copy any changes here to functions/index.tsx's copy
exports.createNewAnswerSurvey = (survey) => {
    return {
        id: survey.id,
        version: survey.version || null,
        name: survey.name,
        description: survey.description,
        questions: survey.questions.filter(question => !!question.value),
        topics: survey.topics,
        logoUrl: survey.logoUrl,
        hideUserStats: survey.hideUserStats,
        endDate: survey.endDate,
        maxNumDays: survey.maxNumDays,
        type: survey.type,
        dateSubmitted: null,
        dateStarted: null,
        dateReceived: exports.timeSinceEpoch(),
        isComplete: false,
        isStarted: false,
    };
};
exports.createEmptyQuestion = (topic) => ({
    id: shortid_1.default.generate(),
    type: QuestionTypes.trueFalse,
    value: '',
    choices: exports.createEmptyResponses(QuestionTypes.trueFalse),
    topic: topic || '',
    // required: false,
    required: true,
    infoTitle: null,
    info: null,
    hasImportantScale: false,
});
//# sourceMappingURL=index.js.map